/**
 * Re-match related product cards when shopper changes Gemstone / Gold Color.
 * Ranking: exact gem+gold (120) > gem only (70) > gold only (40) > soft (0).
 * Resolves options from option1/2/3, variant title ("A / B"), or image filename
 * (…-amethyst-rose-1.webp) because product_reference variants can lack .options.
 */
(function () {
  const root = document.querySelector('[data-veroni-related]');
  if (!root) return;

  const GEM_NAMES = ['gemstone', 'colored stone', 'stone'];
  const GOLD_NAMES = ['gold color', 'color', 'metal'];

  const GEM_SLUGS = [
    ['green-amethyst', 'Green Amethyst'],
    ['blue-topaz', 'Blue Topaz'],
    ['white-topaz', 'White Topaz'],
    ['pink-topaz', 'Pink Topaz'],
    ['green-sapphire', 'Green Sapphire'],
    ['pink-sapphire', 'Pink Sapphire'],
    ['yellow-sapphire', 'Yellow Sapphire'],
    ['amethyst', 'Amethyst'],
    ['sapphire', 'Sapphire'],
    ['ruby', 'Ruby'],
    ['emerald', 'Emerald'],
    ['citrine', 'Citrine'],
    ['garnet', 'Garnet'],
    ['aquamarine', 'Aquamarine'],
    ['tanzanite', 'Tanzanite'],
    ['morganite', 'Morganite'],
    ['peridot', 'Peridot'],
    ['opal', 'Opal'],
    ['diamond', 'Diamond'],
    ['pearl', 'Pearl'],
    ['onyx', 'Onyx'],
    ['tourmaline', 'Tourmaline'],
    ['spinel', 'Spinel'],
    ['moonstone', 'Moonstone'],
    ['kunzite', 'Kunzite'],
    ['tsavorite', 'Tsavorite'],
    ['alexandrite', 'Alexandrite'],
    ['topaz', 'Topaz'],
  ];

  function normalize(s) {
    return (s || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function optionsFromVariant(v) {
    const out = [];
    if (v.option1) out.push(String(v.option1));
    if (v.option2) out.push(String(v.option2));
    if (v.option3) out.push(String(v.option3));
    if (out.length) return out;

    if (Array.isArray(v.options) && v.options.length) {
      return v.options.map(String);
    }

    if (v.title && v.title !== 'Default Title' && v.title.indexOf('/') !== -1) {
      return v.title.split('/').map((s) => s.trim()).filter(Boolean);
    }

    // Filename fallback: product-handle-amethyst-rose-1.webp
    const img = v.image || '';
    if (!img) return out;
    const file = img.split('/').pop().split('?')[0].toLowerCase();
    let gem = '';
    for (const [slug, label] of GEM_SLUGS) {
      if (file.includes(slug)) {
        gem = label;
        break;
      }
    }
    let gold = '';
    if (file.includes('yellow')) gold = 'Yellow Gold';
    else if (file.includes('white')) gold = 'White Gold';
    else if (file.includes('rose')) gold = 'Rose Gold';
    if (gem) out.push(gem);
    if (gold) out.push(gold);
    return out;
  }

  /** Loose option match: "White Gold" ≈ "14k white gold" ≈ "white" */
  function optionMatches(opts, target) {
    if (!target) return true;
    const t = normalize(target);
    if (!t) return true;
    const tCore = t.replace(/\b\d+k\b/g, '').replace(/\bgold\b/g, '').trim();
    return opts.some((o) => {
      const n = normalize(o);
      if (!n) return false;
      if (n === t) return true;
      if (n.includes(t) || t.includes(n)) return true;
      const nCore = n.replace(/\b\d+k\b/g, '').replace(/\bgold\b/g, '').trim();
      if (tCore && nCore && (nCore === tCore || nCore.includes(tCore) || tCore.includes(nCore))) {
        return true;
      }
      return false;
    });
  }

  function selectedOption(aliases) {
    const fieldsets = document.querySelectorAll('fieldset.variant-option, .variant-option');
    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('legend');
      let legendText = '';
      if (legend) {
        const first = legend.childNodes[0];
        legendText = normalize(first && first.textContent);
      }
      if (!aliases.includes(legendText)) continue;
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      const select = fieldset.querySelector('select');
      if (select) return select.value;
    }
    const dropdowns = document.querySelectorAll(
      '.variant-option--dropdowns, .product-form__input, variant-selects'
    );
    for (const wrap of dropdowns) {
      const label = wrap.querySelector('label, legend');
      if (!label || !aliases.includes(normalize(label.textContent))) continue;
      const sel = wrap.querySelector('select');
      if (sel) return sel.value;
      const checked = wrap.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
    }
    return '';
  }

  function scoreVariant(options, gem, gold) {
    const opts = (options || []).map(String);
    const gemN = normalize(gem);
    const goldN = normalize(gold);
    const hasGem = gemN ? optionMatches(opts, gemN) : false;
    const hasGold = goldN ? optionMatches(opts, goldN) : false;

    if (gemN && goldN) {
      if (hasGem && hasGold) return 120;
      if (hasGem) return 70;
      if (hasGold) return 40;
      return 0;
    }
    if (gemN) return hasGem ? 90 : 0;
    if (goldN) return hasGold ? 80 : 0;
    return 20;
  }

  function bestVariant(variants, gem, gold) {
    if (!variants || !variants.length) return null;
    let best = variants[0];
    let bestScore = -1;
    for (const v of variants) {
      const opts = optionsFromVariant(v);
      const s = scoreVariant(opts, gem, gold);
      if (s > bestScore) {
        bestScore = s;
        best = v;
      }
    }
    return { variant: best, score: Math.max(bestScore, 0) };
  }

  function parseVariants(card) {
    const raw = card.getAttribute('data-variants') || '[]';
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (e) {
      /* try unescape */
    }
    try {
      const ta = document.createElement('textarea');
      ta.innerHTML = raw;
      const parsed = JSON.parse(ta.value || '[]');
      if (Array.isArray(parsed)) return parsed;
    } catch (e2) {
      /* ignore */
    }
    return [];
  }

  function rematch() {
    const gem = selectedOption(GEM_NAMES) || root.dataset.selectedGem || '';
    const gold = selectedOption(GOLD_NAMES) || root.dataset.selectedGold || '';
    root.dataset.selectedGem = gem;
    root.dataset.selectedGold = gold;

    const sub = root.querySelector('[data-related-sub]');
    if (sub) {
      if (gem && gold) {
        sub.textContent = `Closest matches in ${gem.toLowerCase()} and ${gold.toLowerCase()}.`;
      } else if (gem) {
        sub.textContent = `Closest matches in ${gem.toLowerCase()}.`;
      } else if (gold) {
        sub.textContent = `Closest matches in ${gold.toLowerCase()}.`;
      } else {
        sub.textContent = 'Pieces that pair by stone, gold, and design language.';
      }
    }

    const cards = Array.from(root.querySelectorAll('[data-related-card]'));
    const ranked = [];

    cards.forEach((card) => {
      const variants = parseVariants(card);
      const result = bestVariant(variants, gem, gold);
      const v = result && result.variant;
      const score = (result && result.score) || 0;
      const baseUrl = card.getAttribute('data-product-url') || '';
      const url = v && v.id ? `${baseUrl}?variant=${v.id}` : baseUrl;

      card.querySelectorAll('[data-related-link]').forEach((a) => {
        a.setAttribute('href', url);
      });

      const img = card.querySelector('[data-related-image]');
      if (img && v && v.image) {
        img.src = v.image;
        img.removeAttribute('srcset');
        const title = (card.querySelector('h3') || {}).textContent || 'Veroni jewelry';
        img.alt = `${gold || ''} ${gem || ''} — ${title.trim()}`.trim();
      }

      const price = card.querySelector('[data-related-price]');
      if (price && v && v.price) price.textContent = v.price;

      let tier = 'soft';
      if (score >= 100) tier = 'exact';
      else if (score >= 50) tier = 'close';
      card.dataset.matchTier = tier;
      card.dataset.matchScore = String(score);

      const badge = card.querySelector('[data-related-badge], .v-design-set__badge');
      if (badge) {
        if (tier === 'exact') {
          badge.textContent = 'Exact match';
          badge.hidden = false;
        } else if (tier === 'close') {
          badge.textContent = 'Close match';
          badge.hidden = false;
        } else {
          badge.textContent = '';
          badge.hidden = true;
        }
      }

      ranked.push({ card, score });
    });

    ranked.sort((a, b) => b.score - a.score);
    const rail = root.querySelector('[data-related-rail]');
    if (rail) {
      ranked.forEach(({ card }) => rail.appendChild(card));
    }
  }

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (!t) return;
    if (t.matches && (t.matches('input[type="radio"]') || t.matches('select'))) {
      window.setTimeout(rematch, 0);
    }
  });

  if ('MutationObserver' in window) {
    const picker = document.querySelector('variant-picker, variant-selects, product-info');
    if (picker) {
      new MutationObserver(() => window.setTimeout(rematch, 30)).observe(picker, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'value', 'aria-checked'],
      });
    }
  }

  rematch();
})();
